import { ANALYTICS_URL, APP_URL, LANDING_URL, TELEGRAM_URL, X_URL } from '@vaultsfyi/common/constants'

interface Props {
  title: string
  description: string
  url: string
  structuredData?: Array<Record<string, unknown>>
}

export const getMetaTags = ({ title, description, url, structuredData = [] }: Props) => {
  const pageTitle = `${title} | vaults.fyi` as const
  const pageUrl = `${APP_URL}${url}`

  return [
    { tagName: 'link' as const, rel: 'canonical', href: pageUrl },
    { title: pageTitle },
    { name: 'description', content: description },

    {
      name: 'fc:frame',
      content: JSON.stringify({
        version: 'next',
        imageUrl: `${APP_URL}/frame.png`,
        button: {
          title: 'Get yield',
          action: {
            type: 'launch_frame',
            name: 'Vaults.fyi',
            url: pageUrl,
            splashImageUrl: `${APP_URL}/farcaster-splash.png`,
            splashBackgroundColor: '#FBFBFF',
          },
        },
      }),
    },

    { property: 'og:title', content: pageTitle },
    { property: 'og:description', content: description },
    { property: 'og:url', content: pageUrl },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'app.vaults.fyi' },
    { property: 'og:locale', content: 'en_US' },
    { property: 'og:image', content: `${APP_URL}/site_preview_image.jpg` },
    { property: 'og:image:width', content: '1200' },
    { property: 'og:image:height', content: '630' },
    { property: 'og:image:alt', content: 'vaults.fyi' },

    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: pageTitle },
    { name: 'twitter:description', content: description },
    { name: 'twitter:site', content: '@vaultsfyi' },
    { name: 'twitter:creator', content: '@vaultsfyi' },
    { name: 'twitter:image', content: `${APP_URL}/site_preview_image.jpg` },

    { name: 'author', content: 'vaults.fyi' },

    {
      'script:ld+json': {
        '@context': 'https://schema.org',
        '@id': `${APP_URL}/#website`,
        '@type': 'WebSite',
        name: 'vaults.fyi',
        url: APP_URL,
        logo: `${APP_URL}/favicon.svg`,
        sameAs: [APP_URL, LANDING_URL, ANALYTICS_URL, X_URL, TELEGRAM_URL],
      },
    },
    ...structuredData.map((data) => ({ 'script:ld+json': data })),
  ]
}
